import { render, staticRenderFns } from "./recordPractice.vue?vue&type=template&id=1920eb64&scoped=true"
import script from "./recordPractice.vue?vue&type=script&lang=js"
export * from "./recordPractice.vue?vue&type=script&lang=js"
import style0 from "./recordPractice.vue?vue&type=style&index=0&id=1920eb64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1920eb64",
  null
  
)

export default component.exports